/**
 * Main page implementation.
 */

'use strict';

/* eslint no-unused-expressions: off */

var pageId               = 'pageMain',
    app                  = require('mag-app'),
    keys                 = require('stb-keys'),
    Panel                = require('mag-component-panel'),
    PanelSet             = require('mag-component-panel-set'),
    LayoutList           = require('mag-component-layout-list'),
    ModalMessage         = require('mag-component-modal'),
    RadioList            = require('mag-component-radio-list'),
    ScrollBar            = require('stb-component-scrollbar'),
    Footer               = require('mag-component-footer'),
    ScrollArea           = require('mag-component-scroll-area'),
    dom                  = require('spa-dom'),
    Weather              = require('../modules/weather'),
    geo                  = require('../modules/geo'),
    appExit              = require('../modules/app.exit'),
    config               = require('../config'),
    keyboardOpen         = require('../modules/keyboard'),
    forecastBuilder      = require('../modules/forecast.builder'),
    page                 = new (require('stb-component-page'))({$node: window[pageId]}),
    forecasts            = {},
    actualLocationsList  = [],
    syncLocationForecast = {},
    sessionTmpSettings   = {},
    celsiusIcon          = '\u00B0C',
    fahrenheitIcon       = '\u00B0F',
    actualSearch         = '',
    mainPanelSet,
    dropdown,
    leftPanel,
    mainPanel,
    menuListView,
    settingsStore,
    locationsStore,
    mainCitiesList,
    menuListScroll,
    mainPanelSettingsList,
    inputContainerList,
    mainPanelTitle;


app.flags = {
    isContextMenuModalShown: false,
    isAddCityModalShown: false,
    isSettingsModalShown: false,
    isDisplaySettings: false,
    isSearchPlaceSuccess: false
};


/** Save user data (locations and settings) to UserFS. */
app.saveData = function () {
    console.log('!!! app.saveData is called');
    console.log(app.userStore);
    console.log(JSON.stringify(app.userStore));
    console.log('--------------------------------------------');

    core.state = app.userStore;
};


/** Open modal window for adding locations on demand. */
function openSearchModalWindow () {
    mainPanel.$node.classList.remove('itemsNewProportions');
    mainPanelSet.hide();
    page.modals.search.show();
    page.modals.search.focus();
}


/** Close modal messages and show main set of panels. */
function closeModalWindow () {
    page.modals.search.hide();
    page.modals.settingsTemperature.hide();
    page.modals.settingsWindSpeedUnits.hide();
    page.modals.locationContextMenu.hide();
    mainPanelSet.focus();
    app.flags.isSettingsModalShown = false;
    app.flags.isAddCityModalShown = false;
    app.flags.isContextMenuModalShown = false;

    if ( !app.isDisplaySettings ) {
        page.footer.show();
    }
}


/**
 * Build appropriate structure for LayoutList in weather details.
 *
 * @param {string} id - id of weather object data in forecasts object
 *
 * @return {Object[]} structure which is appropriate for using in LayoutList
 */
function buildWeatherStructure ( id ) {
    var data;

    try {
        data = forecasts[id];
    } catch ( error ) {
        console.log('Error on getting forecast!\n' + error.message);
    }

    return data;
}


/** Apply user preferences to UI. */
function applySettings () {
    if ( sessionTmpSettings.temperature && settingsStore.temperature !== sessionTmpSettings.temperature ||
         sessionTmpSettings.windSpeedUnits && settingsStore.windSpeedUnits !== sessionTmpSettings.windSpeedUnits ) {
        if ( sessionTmpSettings.temperature && settingsStore.temperature !== sessionTmpSettings.temperature ) {
            settingsStore.temperature = sessionTmpSettings.temperature;
        }

        if ( sessionTmpSettings.windSpeedUnits && settingsStore.windSpeedUnits !== sessionTmpSettings.windSpeedUnits ) {
            settingsStore.windSpeedUnits = sessionTmpSettings.windSpeedUnits;
        }

        app.saveData();

        if ( page.forecastBlock.forecastId ) {
            forecastBuilder.setForecast(page.forecastBlock, buildWeatherStructure(page.forecastBlock.forecastId));
        }
    }
}


/**
 * Parse full name of particular place to get two parts: title and other info.
 *
 * @param {string} line - line for parsing (full display name from response object)
 * @return {Object[]} array of address parts
 */
function parsePlaceLine ( line ) {
    var rePlaceTitle = /^[^,]+/;

    if ( (/^[^,]+$/).test(line) ) {
        return line;
    }

    return [line.match(rePlaceTitle)[0], line.replace(rePlaceTitle, '').slice(2)];
}


/**
 * Re-render lists on data change/some event.
 *
 * @param {Object} elem - element that we want to re-render
 * @param {Object[]} data - new initialization data
 * @param {number} size - size of the list
 * @param {number} sizeLimit - minimum size for displaying scroll
 * @param {Object} scrollType - scroll element
 * @param {Object} [mixin] - set of additional properties
 */
function renderList ( elem, data, size, sizeLimit, scrollType, mixin ) {
    var headerMenuItem = {
            items: [
                {
                    className: 'theme-icon theme-icon-plus' + (data.length ? ' theme-header' : '')
                },
                {
                    value: gettext('Add city'),
                    className: data.length ? 'theme-header' : ''
                }
            ],
            click: openSearchModalWindow
        },
        footerMenuItem = [
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-settings theme-footer'
                    },
                    {
                        value: gettext('Settings'),
                        className: 'theme-footer'
                    }
                ],
                click: function () {
                    if ( !app.isDisplaySettings ) {
                        mainPanelTitle.tmp = mainPanelTitle.innerText;
                        mainPanelTitle.innerText = gettext('settings');
                        page.forecastBlock.hide();
                        mainPanelSettingsList.show();
                        mainPanel.$node.classList.add('itemsNewProportions');
                        page.footer.hide();
                        app.isDisplaySettings = true;
                    }
                }
            },
            {
                items: [
                    {className: 'theme-icon theme-icon-exit'},
                    {value: gettext('Exit')}
                ],
                click: function () {
                    mainPanelSet.blur();
                    appExit.goExit();
                }
            }
        ],
        tmpData = {
            scroll: data.length <= sizeLimit ? null : scrollType,
            size: size,
            data: data || [],
            focusIndex: data.length - 1
        };

    // only for left-side list
    if ( elem === menuListView ) {
        tmpData.data.unshift(headerMenuItem);
        tmpData.data = tmpData.data.concat(footerMenuItem);
    }

    if ( mixin ) {
        Object.keys(mixin).forEach(function ( item ) {
            tmpData[item] = mixin[item];
        });
    }

    if ( scrollType ) {
        if ( tmpData.data.length > sizeLimit ) {
            if ( !elem.scroller ) {
                elem.scroller = 1;
                scrollType.init({
                    realSize: tmpData.data.length
                });
                scrollType.$node.style.display = '';
            }
        } else {
            elem.scroller = 0;
            scrollType.$node.style.display = 'none';
        }
    }

    elem.init(tmpData);
}


/**
 *  Construct appropriate structure for adding to LayoutLists with handlers.
 *
 *  @param {Object[]} places - array of received places (from response)
 *  @return {Object[]} array of ready-to-use in LayoutList objects
 */
function constructDataOut ( places ) {
    return places.map(function ( item ) {
        var placeParts = parsePlaceLine(item.display_name),
            isArray = Array.isArray(placeParts),
            titlePlace = isArray ? placeParts[0] : placeParts,
            location = {
                lat: item.lat,
                lon: item.lon
            },
            // purpose of this is binding locations and corresponding weather
            randomId = ('id' + (Math.random() * Date.now())).replace('.', '');

        return {
            items: [
                {
                    value: titlePlace,
                    className: 'placeTitleListBlock'
                },
                {
                    value: isArray ? placeParts[1] : '',
                    className: 'placeRestListBlock'
                }
            ],
            click: function () {
                var isPlaceAbsent = true,
                    weatherObj, locationItemData, idx; // eslint-disable-line

                for ( idx = locationsStore.length; idx--; ) {
                    if ( locationsStore[idx].lat === location.lat && locationsStore[idx].lon === location.lon ) {
                        isPlaceAbsent = false;
                        break;
                    }
                }

                if ( isPlaceAbsent ) {
                    actualSearch = '';

                    locationItemData = {
                        items: [
                            {
                                className: 'theme-icon theme-icon-cloud-sun-2 ' + randomId
                            },
                            {
                                value: titlePlace,
                                className: 'addPlaceTitle'
                            }
                        ],
                        value: {
                            id: randomId,
                            lat: location.lat,
                            lon: location.lon,
                            fullName: item.display_name
                        },
                        click: function () {
                            if ( app.isDisplaySettings ) {
                                applySettings();
                                mainPanelTitle.innerText = mainPanelTitle.tmp;
                                mainPanelSettingsList.hide();
                                page.forecastBlock.show();
                                mainPanel.$node.classList.remove('itemsNewProportions');
                                page.footer.show();
                                app.isDisplaySettings = false;
                                menuListView.emit('focus:item', {$curr: {index: menuListView.$focusItem.index}});
                            }
                        }
                    };

                    syncLocationForecast[randomId] = locationItemData;
                    actualLocationsList.push(locationItemData);
                    renderList(
                        menuListView,
                        actualLocationsList.slice(),
                        actualLocationsList.length > 4 ? 7 : actualLocationsList.length + 3,
                        7,
                        menuListScroll,
                        {focusIndex: actualLocationsList.length}
                    );

                    // store selected place to storage. In current case user adds location
                    locationsStore.push({
                        fullName: item.display_name,
                        shortName: titlePlace,
                        lat: location.lat,
                        lon: location.lon
                    });

                    console.log('!!! prepare for saveData');
                    console.log(locationsStore);
                    console.log(JSON.stringify(locationsStore));
                    console.log('--------------------------------------------');

                    app.saveData();

                    weatherObj = new Weather({location: location}, function ( forecast ) {
                        var index;

                        forecasts[randomId] = forecast;

                        for ( index = actualLocationsList.length; index--; ) {
                            if ( actualLocationsList[index].value.id === randomId ) {
                                actualLocationsList[index] = syncLocationForecast[randomId];
                            }
                        }

                        page.forecastBlock.forecastId = randomId;
                        forecastBuilder.setForecast(page.forecastBlock, buildWeatherStructure(randomId));
                    });
                }

                dropdown.init({
                    size: 5,
                    data: []
                });

                inputContainerList.$body.children[0].children[0].children[1].innerText =
                    inputContainerList.$body.children[0].children[0].children[1].parentNode.parentNode.data.value.defaultValue;
                mainPanelSet.show();
                closeModalWindow();
            }
        };
    });
}


/**
 * Search data by Geo service with given user input.
 *
 * @param {string} value - search string
 */
function searchPlaces ( value ) {
    if ( value ) {
        geo.search({
            language: core.environment.language,
            query: value
        }, function ( response ) {
            if ( response && response.length ) {
                app.flags.isSearchPlaceSuccess = true;
                renderList(dropdown, constructDataOut(response), 5, 5, null);
                dropdown.blurItem(dropdown.$focusItem);
            } else {
                app.flags.isSearchPlaceSuccess = false;
                renderList(dropdown, [], 5, 5, null);
            }
        });
    }
}


/**
 * Delete particular city with notification before.
 */
function deleteCity () {
    core.notify({
        title: gettext('Are you sure you want to delete this location?'),
        icon: 'info',
        type: '',
        buttons: [
            {value: gettext('Cancel')},
            {
                value: gettext('Ok'),
                click: function () {
                    var target = menuListView.$focusItem,
                        id = target.data.value.id,
                        idx;

                    // remove particular location from all storage structures
                    for ( idx = locationsStore.length; idx--; ) {
                        if ( locationsStore[idx].lat === target.data.value.lat && locationsStore[idx].lon === target.data.value.lon ) {
                            locationsStore.splice(idx, 1);
                            break;
                        }
                    }
                    app.saveData();

                    // remove particular location from all runtime structures
                    delete syncLocationForecast[id];
                    delete forecasts[id];
                    actualLocationsList = actualLocationsList.filter(function (item ) {
                        return item.value.id !== id;
                    });

                    // render list with deleted location
                    renderList(
                        menuListView,
                        actualLocationsList.slice(),
                        actualLocationsList.length > 4 ? 7 : actualLocationsList.length + 3,
                        7,
                        menuListScroll,
                        {focusIndex: actualLocationsList.length ? target.index : 0}
                    );

                    if ( !actualLocationsList.length ) {
                        forecastBuilder.setNoData(page.forecastBlock);
                        mainPanelTitle.innerText = gettext('No cities');
                    }

                    closeModalWindow();
                }
            }
        ]
    });
}


/**
 * Construct set of menu items according to context.
 *
 * @param {string} mask - set of active/inactive items
 * @return {Object[]} actions
 */
function modifyContextMenuByMask ( mask ) {
    var template = [
        {
            items: [
                {
                    className: 'theme-icon theme-icon-rc-f2'
                },
                gettext('Add city')
            ],
            click: function () {
                openSearchModalWindow.itemToReturn = {idx: menuListView.$focusItem.index};
                closeModalWindow();
                openSearchModalWindow();
            }
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-rc-f1'
                },
                gettext('Delete city')
            ],
            click: deleteCity
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-up'
                },
                gettext('Move up')
            ],
            click: function () {
                var target = menuListView.$focusItem,
                    idx = target.index - 1,
                    tmp;

                tmp = actualLocationsList[idx - 1];
                actualLocationsList[idx - 1] = actualLocationsList[idx];
                actualLocationsList[idx] = tmp;
                renderList(
                    menuListView,
                    actualLocationsList.slice(),
                    actualLocationsList.length > 4 ? 7 : actualLocationsList.length + 3,
                    7,
                    menuListScroll,
                    {focusIndex: idx}
                );
                closeModalWindow();
            }
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-down'
                },
                gettext('Move down')
            ],
            click: function () {
                var target = menuListView.$focusItem,
                    idx = target.index - 1,
                    tmp;

                tmp = actualLocationsList[idx + 1];
                actualLocationsList[idx + 1] = actualLocationsList[idx];
                actualLocationsList[idx] = tmp;
                renderList(
                    menuListView,
                    actualLocationsList.slice(),
                    actualLocationsList.length > 4 ? 7 : actualLocationsList.length + 3,
                    7,
                    menuListScroll,
                    {focusIndex: idx + 2}
                );
                closeModalWindow();
            }
        }
    ];

    return template.filter(function ( item, idx ) {
        return +mask[idx];
    });
}


/**
 * Render whole page (all panels + auxiliary nodes).
 *
 * @param {Object[]} data - array of structured items for using in LayoutLists
 * @param {Object[]} settings - user settings for application "Settings"
 */
function renderPage ( data, settings ) { // eslint-disable-line
    var dataLength = data.length,
        inputDelay = config.searchInputDelay,
        contextMenuEventHook = {
            keydown: function ( event ) {
                LayoutList.prototype.defaultEvents.keydown.call(this, event);
                if ( event.code === keys.back || event.code === keys.menu ) {
                    event.stop = true;
                    closeModalWindow();
                }
            }
        },
        headerMenuItem = [
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-plus' + (data.length ? ' theme-header' : '')
                    },
                    {
                        value: gettext('Add city'),
                        className: data.length ? 'theme-header' : ''
                    }
                ],
                click: openSearchModalWindow
            }
        ],
        footerMenuItem = [
            {
                items: [
                    {
                        className: 'theme-icon theme-icon-settings theme-footer'
                    },
                    {
                        value: gettext('Settings'),
                        className: 'theme-footer'
                    }
                ],
                click: function () {
                    if ( !app.isDisplaySettings ) {
                        mainPanelTitle.tmp = mainPanelTitle.innerText;
                        mainPanelTitle.innerText = gettext('settings');
                        page.forecastBlock.hide();
                        mainPanelSettingsList.show();
                        mainPanel.$node.classList.add('itemsNewProportions');
                        page.footer.hide();
                        app.isDisplaySettings = true;
                    }
                }
            },
            {
                items: [
                    {
                        value: '',
                        className: 'theme-icon theme-icon-exit'
                    },
                    {
                        value: gettext('Exit'),
                        className: ''
                    }
                ],
                click: function () {
                    mainPanelSet.blur();
                    appExit.goExit();
                }
            }
        ],
        settingsListData, contextMenuList;

    page.modals = {};


    function observeMenuListView () {
        var id;

        if ( menuListView.$focusItem.data && menuListView.$focusItem.data.value && menuListView.$focusItem.data.value.fullName ) {
            id = menuListView.$focusItem.data.value.id;
            mainPanelTitle.innerText = menuListView.$focusItem.data.value.fullName;
            page.footer.init(page.footer.onCityConfig);

            page.forecastBlock.forecastId = id;

            forecastBuilder.setForecast(page.forecastBlock, buildWeatherStructure(id));
        } else {
            page.footer.init(page.footer.noCityConfig);
        }
    }


    page.footer = new Footer({parent: page});

    page.footer.noCityConfig = {
        left: {code: keys.menu, action: function () {
            contextMenuList.init({
                size: 1,
                data: modifyContextMenuByMask('1000'),
                events: contextMenuEventHook
            });
            mainPanelSet.blur();
            setTimeout(function () { page.modals.locationContextMenu.show(); }, 0);
            page.footer.hide();
        }},
        middle: [{code: keys.f2, title: gettext('Add city'), action: openSearchModalWindow}]
    };

    page.footer.onCityConfig = {
        left: {code: keys.menu, action: function () {
            var target = menuListView.$focusItem;

            if ( actualLocationsList.length > 1 ) {
                if ( target.index === 1 ) {
                    contextMenuList.init({
                        size: 3,
                        data: modifyContextMenuByMask('1101'),
                        events: contextMenuEventHook
                    });
                } else if ( target.index - 1 === actualLocationsList.length - 1 ) {
                    contextMenuList.init({
                        size: 3,
                        data: modifyContextMenuByMask('1110'),
                        events: contextMenuEventHook
                    });
                } else {
                    contextMenuList.init({
                        size: 4,
                        data: modifyContextMenuByMask('1111'),
                        events: contextMenuEventHook
                    });
                }
            } else {
                contextMenuList.init({
                    size: 2,
                    data: modifyContextMenuByMask('1100'),
                    events: contextMenuEventHook
                });
            }

            mainPanelSet.blur();
            setTimeout(function () { page.modals.locationContextMenu.show(); }, 0);
            page.footer.hide();
        }},
        middle: [
            {code: keys.f1, title: gettext('Delete'), action: deleteCity},
            {code: keys.f2, title: gettext('Add city'), action: openSearchModalWindow}
        ]
    };

    settingsListData = [
        {
            items: [
                {
                    value: gettext('temperature')
                },
                {
                    value: (function () {
                        if ( settings && settings.temperature ) {
                            return settings.temperature === 'C' ? celsiusIcon : fahrenheitIcon;
                        }

                        return celsiusIcon;
                    })(),
                    className: 'optionTemperatureIndicator theme-text-disabled'
                }
            ],
            click: function () {
                mainPanelSet.blur();
                page.modals.settingsTemperature.show();
                page.modals.settingsTemperature.focus();
                app.flags.isSettingsModalShown = true;
            }
        },
        {
            items: [
                {
                    value: gettext('Wind speed')
                },
                {
                    value: settings && settings.windSpeedUnits ? gettext(settings.windSpeedUnits) : gettext('m/s'),
                    className: 'optionWindSpeedIndicator theme-text-disabled'
                }
            ],
            click: function () {
                mainPanelSet.blur();
                page.modals.settingsWindSpeedUnits.show();
                page.modals.settingsWindSpeedUnits.focus();
                app.flags.isSettingsModalShown = true;
            }
        }
    ];

    menuListScroll = new ScrollBar({
        viewSize: 7,
        realSize: dataLength
    });

    page.modals.search = new ModalMessage({
        className: 'searchPlaceModalWindow',
        title: gettext('Add city'),
        events: {
            show: function () {
                inputContainerList.focusIndex(0);

                keyboardOpen({
                    title: gettext('Add city'),
                    elemSelector: inputContainerList.$body.children[0].children[0].children[1],
                    value: actualSearch
                }, function ( event ) {
                    setTimeout(function () {
                        searchPlaces(actualSearch = event.value.trim());
                    }, inputDelay);
                });

                app.flags.isAddCityModalShown = true;
                page.footer.hide();
            },
            hide: function () {
                mainPanelSet.show();
                mainPanelSet.focus();
                page.footer.show();
            }
        },
        children: [
            inputContainerList = new LayoutList({
                size: 1,
                data: [
                    {
                        items: [
                            {
                                value: '',
                                className: 'theme-icon theme-icon-search'
                            },
                            {
                                value: gettext('Search'),
                                className: 'inputSearch'
                            }
                        ],
                        value: {
                            defaultValue: gettext('Search')
                        },
                        click: function () {
                            keyboardOpen({
                                title: gettext('Add city'),
                                elemSelector: inputContainerList.$body.children[0].children[0].children[1],
                                value: actualSearch
                            }, function ( event ) {
                                setTimeout(function () {
                                    searchPlaces(actualSearch = event.value.trim());
                                }, inputDelay);
                            });
                        }
                    }
                ],
                events: {
                    overflow: function ( evt ) {
                        if ( evt.direction === keys.down ) {
                            if ( app.flags.isSearchPlaceSuccess ) {
                                this.blurItem(this.$focusItem);
                                dropdown.focus();
                                dropdown.focusIndex(0);
                            }
                        }
                    }
                }
            }),
            dropdown = new LayoutList({
                className: 'padded',
                events: {
                    overflow: function ( evt ) {
                        if ( evt.direction === keys.up ) {
                            dropdown.blurItem(dropdown.$focusItem);
                            inputContainerList.focus();
                            inputContainerList.focusIndex(0);
                        }
                    }
                }
            })
        ]
    });

    page.modals.settingsTemperature = new ModalMessage({
        title: gettext('units'),
        events: {
            show: function () {
                page.modals.settingsTemperature.children[0].focus();
                app.flags.isSettingsModalShown = true;
            }
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 2,
                events: {
                    'click:item': function ( evt ) {
                        if ( evt.$item.value ) {
                            mainPanelSettingsList.$focusItem.children[0].children[1].innerText = fahrenheitIcon;
                            sessionTmpSettings.temperature = 'F';
                        } else {
                            mainPanelSettingsList.$focusItem.children[0].children[1].innerText = celsiusIcon;
                            sessionTmpSettings.temperature = 'C';
                        }
                        closeModalWindow();
                    }
                },
                data: [
                    {
                        state: settingsStore ? (settingsStore.temperature === 'C') : true,
                        title: gettext('Celsius'),
                        value: 0
                    },
                    {
                        state: settingsStore ? (settingsStore.temperature === 'F') : false,
                        title: gettext('Fahrenheit'),
                        value: 1
                    }
                ]
            })
        ]
    });

    page.modals.settingsWindSpeedUnits = new ModalMessage({
        title: gettext('units'),
        events: {
            show: function () {
                page.modals.settingsWindSpeedUnits.children[0].focus();
                app.flags.isSettingsModalShown = true;
            }
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 3,
                events: {
                    'click:item': function ( evt ) {
                        if ( evt.$item.value === 2 ) {
                            mainPanelSettingsList.$focusItem.children[0].children[1].innerText = gettext('m/h');
                            sessionTmpSettings.windSpeedUnits = 'm/h';
                        } else if ( evt.$item.value === 1 ) {
                            mainPanelSettingsList.$focusItem.children[0].children[1].innerText = gettext('km/h');
                            sessionTmpSettings.windSpeedUnits = 'km/h';
                        } else {
                            mainPanelSettingsList.$focusItem.children[0].children[1].innerText = gettext('m/s');
                            sessionTmpSettings.windSpeedUnits = 'm/s';
                        }
                        closeModalWindow();
                    }
                },
                data: [
                    {
                        state: settingsStore ? (settingsStore.windSpeedUnits === 'm/s') : true,
                        title: gettext('m/s'),
                        value: 0
                    },
                    {
                        state: settingsStore ? (settingsStore.windSpeedUnits === 'km/h') : false,
                        title: gettext('km/h'),
                        value: 1
                    },
                    {
                        state: settingsStore ? (settingsStore.windSpeedUnits === 'm/h') : false,
                        title: gettext('m/h'),
                        value: 2
                    }
                ]
            })
        ]
    });

    page.modals.locationContextMenu = new ModalMessage({
        title: gettext('actions'),
        events: {
            show: function () {
                page.modals.locationContextMenu.focus();
                contextMenuList.focusIndex(0);
                app.flags.isContextMenuModalShown = true;
            },
            hide: closeModalWindow
        },
        children: [
            contextMenuList = new LayoutList({
                cycle: true,
                focusIndex: 0,
                size: 0,
                data: []
            })
        ]
    });

    page.forecastBlock = new ScrollArea({propagate: true});
    page.add(page.modals.search);
    page.add(page.modals.settingsTemperature);
    page.add(page.modals.settingsWindSpeedUnits);
    page.add(page.modals.locationContextMenu);

    page.add(
        mainPanelSet = new PanelSet({
            panels: [
                leftPanel = new Panel({
                    size: 1,
                    title: gettext('menu'),
                    children: [
                        menuListView = new LayoutList({
                            cycle: true,
                            size: data.length > 4 ? 7 : data.length + 3,
                            focusIndex: +!!data.length,
                            data: headerMenuItem.concat(data, footerMenuItem),
                            scroll: menuListScroll,
                            events: {
                                'focus:item': function ( evt ) {
                                    if ( !app.mainPanelSet || app.isDisplaySettings ) {
                                        return;
                                    }

                                    if ( evt.$curr && evt.$curr.index ) {
                                        observeMenuListView();
                                    } else {
                                        page.footer.init(page.footer.noCityConfig);
                                    }
                                },
                                'move:view': function ( evt ) {
                                    if ( !app.mainPanelSet || app.isDisplaySettings ) {
                                        return;
                                    }

                                    if ( evt.currIndex === 1 || (evt.currIndex > 1 && evt.prevIndex) ) {
                                        observeMenuListView();
                                    } else {
                                        page.footer.init(page.footer.noCityConfig);
                                    }
                                }
                            }
                        })
                    ],
                    events: {
                        focus: function ( event ) {
                            Panel.prototype.defaultEvents.focus.call(this, event);
                            if ( menuListView.$focusItem ) {
                                page.footer.init(page.footer[(menuListView.$focusItem.data.value ? 'on' : 'no') + 'CityConfig']);
                            }
                        }
                    }
                }),
                mainPanel = new Panel({
                    size: 2,
                    title: [
                        {
                            className: 'forecastLocationInfo'
                        },
                        dom.tag('div', {className: 'amountContainer'}, dom.tag('div', {className: 'forecastUpdateInfo'}, ''))
                    ],
                    main: true,
                    children: [
                        page.forecastBlock,
                        mainPanelSettingsList = new LayoutList({
                            className: 'padded',
                            cycle: true,
                            visible: false,
                            focusIndex: 0,
                            size: 2,
                            data: settingsListData
                        })
                    ],
                    events: {
                        focus: function ( event ) {
                            Panel.prototype.defaultEvents.focus.call(this, event);
                            page.footer.init(page.footer[(actualLocationsList.length ? 'on' : 'no') + 'CityConfig']);
                        }
                    }
                })
            ]
        })
    );

    forecastBuilder.init(page.forecastBlock, data[0]);
    app.mainPanelSet = mainPanelSet;
    mainPanelTitle = mainPanel.title.$node.children[0];
    leftPanel.$body.appendChild(menuListScroll.$node);

    if ( data.length ) {
        page.footer.init(page.footer.onCityConfig);
        mainPanel.focus();
        mainPanelTitle.innerText = data[0].value.fullName;
    } else {
        page.footer.init(page.footer.noCityConfig);
        leftPanel.focus();
        mainPanelTitle.innerText = gettext('No cities');
    }

    page.footer.show();
    mainPanel.add(page.forecastBlock);

    if ( data.length <= 4 ) {
        menuListScroll.$node.style.display = 'none';
    }

    mainPanel.addListener('focus', function () {
        app.isDisplaySettings && mainPanelSettingsList.focus();
    });

    inputContainerList.$body.firstElementChild.classList.add('bgDarken');
}


/**
 * Construct stored user data for using in components.
 *
 * @param {Object[]} data - data to parse
 * @return {Object[]} prepared data
 */
function prepareUserDataToRender ( data ) {
    if ( data ) {
        return data.map(function ( item, idx ) {
            // purpose of this is binding locations and corresponding weather
            var randomId = ('id' + (Math.random() * Date.now())).replace('.', ''),
                locationItemData = {
                    items: [
                        {
                            className: 'theme-icon theme-icon-cloud-sun-2 ' + randomId
                        },
                        {
                            value: item.shortName,
                            className: 'addPlaceTitle'
                        }
                    ],
                    value: {
                        id: randomId,
                        lat: item.lat,
                        lon: item.lon,
                        fullName: item.fullName
                    },
                    click: function () {
                        if ( app.isDisplaySettings ) {
                            applySettings();
                            mainPanelTitle.innerText = mainPanelTitle.tmp;
                            mainPanelSettingsList.hide();
                            page.forecastBlock.show();
                            mainPanel.$node.classList.remove('itemsNewProportions');
                            page.footer.show();
                            app.isDisplaySettings = false;
                            menuListView.emit('focus:item', {$curr: {index: menuListView.$focusItem.index}});
                        }
                    }
                },
                weatherObj; // eslint-disable-line

            syncLocationForecast[randomId] = locationItemData;
            actualLocationsList.push(locationItemData);

            weatherObj = new Weather({
                location: {
                    lat: item.lat,
                    lon: item.lon
                }
            }, function ( forecast ) {
                forecasts[randomId] = forecast;
                actualLocationsList.length = 0;
                Object.keys(syncLocationForecast).forEach(function ( location ) {
                    actualLocationsList.push(syncLocationForecast[location]);
                });

                page.forecastBlock.forecastId = randomId;

                if ( idx === menuListView.$focusItem.index - 1 ) {
                    forecastBuilder.setForecast(page.forecastBlock, buildWeatherStructure(randomId));
                }
            });

            return locationItemData;
        });
    }

    return [];

}


page.once('show', function () {
    document.getElementById('forecast').classList.add('hiddenBlock');

    if ( app.userStore ) {
        locationsStore = app.userStore.locations || [];
        settingsStore = app.userStore.settings || {};

        if ( locationsStore.length ) {
            document.getElementById('forecast').classList.remove('hiddenBlock');
        }

        renderPage(prepareUserDataToRender(locationsStore), settingsStore);
    } else {
        renderPage([], null);
        app.userStore = {};
        locationsStore = app.userStore.locations = [];
        settingsStore = app.userStore.settings = {};
    }
    settingsStore.temperature = settingsStore.temperature || 'C';
    settingsStore.windSpeedUnits = settingsStore.windSpeedUnits || 'm/s';
    app.saveData();
});

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( app.flags.isSettingsModalShown || app.flags.isAddCityModalShown || app.flags.isContextMenuModalShown ) {
                if ( app.flags.isAddCityModalShown ) {
                    actualSearch = '';
                    dropdown.init({
                        size: 5,
                        data: []
                    });
                    inputContainerList.$body.children[0].children[0].children[1].innerText =
                        inputContainerList.$body.children[0].children[0].children[1].parentNode.parentNode.data.value.defaultValue;
                }

                closeModalWindow();
                mainPanelSet.show();

                if ( openSearchModalWindow.itemToReturn ) {
                    mainPanel.focus();
                    mainCitiesList.focusIndex(openSearchModalWindow.itemToReturn.idx);
                    openSearchModalWindow.itemToReturn = null;
                }
            } else {
                appExit.goBack();
            }
            break;
    }
});


module.exports = page;
